var image_viewer_rtlignore_default = {
  "fontElementMap": "FwFvx",
  "imageContainer": "e2Rew",
  "expandContainer": "MaTzv",
  "expandIcon": "Y-yeD",
  "pointer": "_5ZJQW",
  "imageWrapper": "wY-mT",
  "imageRatio": "CWaBm",
  "image": "anGb1",
  "imageOverlay": "_3-sdp",
  "imageCaption": "SyVID",
  "imagePreload": "Id9c0",
  "imageHighres": "E-eWW",
  "onlyHighRes": "Uzzt1",
  "image_loading": "eEbEW"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
